<template>
  <b-modal
    size="md"
    :style="{ zIndex: 200 }"
    v-model="isVisible"
    class="modal"
    hide-footer
    no-close-on-backdrop
    centered
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Convert into user</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons"> close </span>
      </button>
    </template>

    <FormGenerator
      ref="form"
      :data="form"
      :isLoading="loading"
      @submit="submit"
    >
      <template v-slot:skills="{ data }">
        <b-form-group>
          <label>{{ data.label }}</label>
          <UserProfileSkills v-model="data.value" />
        </b-form-group>
      </template>
    </FormGenerator>
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import { mapGetters } from 'vuex'

export default {
  components: {
    FormGenerator
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      default: null
    }
  },

  data () {
    return {
      loading: false,
      form: {
        name: {
          type: 'input',
          typeInput: 'email',
          name: 'email',
          label: 'Email',
          placeholder: 'Email',
          valueField: 'value',
          validation: [{ name: 'required' }],
          value: null,
          class: 'col-12'
        },
        password: {
          type: 'input',
          name: 'password',
          label: 'Password',
          typeInput: 'password',
          valueField: 'value',
          validation: [{ name: 'required' }],
          value: null,
          class: 'col-12'
        },
        'roles': {
          type: 'multiselect',
          name: 'roles',
          label: 'Roles',
          valueField: 'id',
          selectLabel: 'display_name',
          placeholder: 'Roles',
          validation: [{ name: 'required' }],
          options: [],
          value: null,
          class: 'col-12'
        },
        start_date: {
          type: 'datepicker',
          name: 'start_date',
          label: 'Start date',
          format: 'dd/MM/yyyy',
          value: new Date(),
          class: 'col-12',
          valueField: 'value',
          validation: [{ name: 'required' }]
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      getUserRoles: 'getRoles'
    }),
    isVisible: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    (async () => {
      Promise.all([
        this.$api.roles.getRoles()
      ]).then(() => {
        this.form.roles.options = this.getUserRoles
      })
    })()
  },

  methods: {
    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const fieldName = field['name']
        let fieldValue = fields[key]['value']

        if (Array.isArray(fieldValue)) {
          fieldValue = fieldValue.map(
            (item) => item[fields[key]['valueField']]
          )
        } else if (typeof fieldValue === 'object' && fieldValue) {
          let fieldKey = fields[key]['valueField']
          fieldValue = fieldKey
            ? fieldValue[fields[key]['valueField']]
            : fieldValue
        }

        data[fieldName] = fieldValue
      }

      return data
    },

    submit (data) {
      const formData = this.prepareDataForRequest(data)
      this.loading = true

      this.axios.post(
        `/api/users/profiles/${this.userId}/convert-into-user`,
        formData,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.$snotify.success('The user profile successfully converted into a user', 'Success', this.$store.state.snotify)
        }
        this.isVisible = false
        this.loading = false
        this.$router.push({ name: 'home' })
      }).catch(err => {
        var errors = Object.values(err.response.data.errors ? err.response.data.errors : {})
        if (errors.length > 0) {
          this.errorNotifications(err)
        } else {
          this.$snotify.error(err.message, 'Error', this.$store.state.snotify)
        }
        this.loading = false
      })
    }
  }
}
</script>
